import { useEffect, useState } from 'react'

/** True quando la tastiera virtuale riduce il viewport visivo: la barra e il FAB si nascondono. */
export function useVirtualKeyboardOpen(): boolean {
  const [open, setOpen] = useState(false)
  useEffect(() => {
    const vv = window.visualViewport
    if (!vv) return undefined
    const check = () => setOpen(window.innerHeight - vv.height > 150 && vv.scale <= 1.01)
    check()
    vv.addEventListener('resize', check)
    return () => vv.removeEventListener('resize', check)
  }, [])
  return open
}
